import { SfSelectFormField, SfSelectOption } from 'ngx-smart-form';
import { genRowsRecord } from '../configs/rows-record';
import { SectionId } from '../configs/section-id-enum';
import { SagittaScoreAreaDto } from '../dto/sagitta-score-area-dto';
import { SagittaScoreDto } from '../dto/sagitta-score-dto';
import { SagittaScoreSectionDto } from '../dto/sagitta-score-section-dto';
import { SagittaScoreSummaryDto } from '../dto/sagitta-score-summary-dto';
import { SagittaScoreArea } from './sagitta-score-area';
import { SagittaScoreElement } from './sagitta-score-element';
import { SagittaScore } from './sagitta-score-model';
import { SagittaScoreRow } from './sagitta-score-row';
import { SagittaScoreSection } from './sagitta-score-section';
import { GaranteGiuridico } from '../../anagraphics/models/garante-giuridico';
import { Section } from '../../aml-score/aml-score-config/aml-score-model';
import { getAmlScoreConfig } from '../../../assets/aml-config/aml-score-config';

export class SagittaScoreFactory {
  static saveScore(score: SagittaScore) {
    let scoreDto: SagittaScoreDto = {
      overallScore: this.round(score.overallScore) || 0,
      overallEsgScore: this.round(score.overallEsgScore),
      overallEvaluation: score.overallEvaluation,
      summary: this.genScoreSummary(score),
      areas:
        score?.areas?.map((score) => {
          return SagittaScoreArea.genDto(score);
        }) || [],
    };
    return scoreDto;
  }

  static getAmlScore(
    configSections: Section[],
    //garanti: GaranteGiuridico[],
    scoreDto?: SagittaScoreDto
  ) {
    /* let fiduciariaIx = -1;
    if (!(garanti?.length > 0)) {
      fiduciariaIx = configSections.findIndex(
        (section) => section.title === 'FIDUCIARIA'
      );
      if (fiduciariaIx > -1) {
        configSections.splice(fiduciariaIx, 1);
      }
    } */

    let amlSections = scoreDto?.areas[0].sections.map((s) => ({
      ...s,
      id: s.id.toUpperCase(),
    }));
    let scoreSections = configSections.map((section, sIx) => {
      let questions = section.questions;
      let elements: SagittaScoreElement[] = questions.map((question, fIx) => {
        let questionId = question.id.toString();
        let element: Partial<SagittaScoreElement> = {
          id: questionId,
          selectionValue: amlSections?.[sIx]?.rows?.[0]?.elements?.find(
            (el) => el.id === questionId
          )?.selectionValue,
          description: question.description,
        };
        return SagittaScoreFactory.buildElement(
          element,
          element.id!,
          'X',
          question.weight * 100,
          100,
          question.options.map((option) => ({
            view: option.view,
            value: { ...option, id: option.id?.toString() },
          })),
          (
            o1: SfSelectOption & { id: string | number },
            o2: SfSelectOption & { id: string | number }
          ) => o1?.id === o2?.id,
          question.disabled,
          question.parent,
          question.parentMatchValue
        );
      });
      let row = new SagittaScoreRow('', elements);

      return new SagittaScoreSection(
        '',
        section.title as SectionId,
        section.title,
        100,
        [row]
      );
    });
    const score = new SagittaScore(0, 0, 'LOW', [
      new SagittaScoreArea('', 'X', 1, scoreSections),
    ]);
    return score;
  }

  static getScore(
    scoreDto: SagittaScoreDto | null,
    areasConfig: SagittaScoreAreaDto[]
  ): SagittaScore {
    let areas = scoreDto
      ? areasConfig.map((mockArea, i) => ({
          ...scoreDto.areas[i],
          sections: mockArea.sections.map((mockSection, j) => {
            let existingSection = scoreDto.areas[i].sections.find(
              (sect) => sect.title === mockSection.title
            );
            return existingSection || mockSection;
          }),
        }))
      : areasConfig;
    let sagittaScore = new SagittaScore(
      scoreDto?.overallScore || 0,
      scoreDto?.overallEsgScore || 0,
      scoreDto?.overallEvaluation || 'LOW',
      areas.map((area) => this.buildArea(area))
    );
    console.log(sagittaScore);
    return sagittaScore;
  }

  static buildArea(area: SagittaScoreAreaDto) {
    return new SagittaScoreArea(
      area.title,
      area.area,
      area.weight,
      area.sections.map((section, sectionIndex) =>
        this.buildSection(section, sectionIndex, area.area)
      )
    );
  }

  static buildSection(
    section: SagittaScoreSectionDto,
    sectionIndex: number,
    area: SagittaScoreArea['area']
  ) {
    return new SagittaScoreSection(
      section.noteFieldsValue,
      section.id,
      section.title,
      section.weight || 0,
      this.buildRows(
        sectionIndex,
        section.weight || 0,
        section.id,
        area,
        section.rows || []
      )
    );
  }

  static buildRows(
    blockIndex: number,
    sectionWeight: number,
    sectionId: string,
    classLevel: SagittaScoreArea['area'],
    rows: { description: string; elements: Partial<SagittaScoreElement>[] }[]
  ) {
    const rowsRecord = genRowsRecord();
    const allRows = rowsRecord[classLevel];
    const sectionRows = allRows?.[blockIndex];
    return (
      sectionRows?.map((row, i) =>
        SagittaScoreRow.buildRow(
          row.description,
          row.options,
          row.kriWeight,
          row.id,
          sectionId,
          sectionWeight,
          classLevel,
          rows[i],
          row.elements
        )
      ) || []
    );
  }

  static buildElement(
    element: Partial<SagittaScoreElement>,
    id: string,
    classLevel: SagittaScoreArea['area'],
    kriWeight: number,
    sectionWeight: number,
    options: SfSelectOption<any>[] = [
      { value: 1, view: 'SI' },
      { value: 0, view: 'NO' },
    ],
    compareWithFunction?: (o1: any, o2: any) => boolean,
    disabled?: boolean,
    parent?: string,
    parentMatchValue?: any
  ) {
    let elementValue = element.selectionValue;
    if (
      classLevel === 'A' &&
      id !== SectionId.identificazioneDelSettore &&
      element.selectionValue
    ) {
      elementValue = element.selectionValue === 'SI' ? 1 : 0;
    }
    let mappedElement = new SagittaScoreElement(
      element.description || '',
      new SfSelectFormField({
        formControlName: id,
        options: options,
        required: element.field?.required || classLevel !== 'E',
        value: elementValue,
        label: element.description || element.field?.formControlName,
        disabled,
        parent,
        parentMatchValue,
        compareWithFunction,
      }),
      element.kriPoints || 0,
      kriWeight,
      id,
      sectionWeight,
      elementValue
    );
    return mappedElement;
  }

  static genScoreSummary(score: SagittaScore) {
    const B = score.areas.find((area) => area.area === 'B');
    const C = score.areas.find((area) => area.area === 'C');
    const D = score.areas.find((area) => area.area === 'D');
    const E = score.areas.find((area) => area.area === 'E');
    let summary: SagittaScoreSummaryDto = {
      scoreA: null,
      weightA: null,
      scoreB: (B?.base100 || 0).toFixed(),
      weightB: (B?.weight || 0).toFixed(1),
      scoreC: (C?.base100 || 0).toFixed(),
      weightC: (C?.weight || 0).toFixed(1),
      scoreD: (D?.base100 || 0).toFixed(),
      weightD: (D?.weight || 0).toFixed(1),
      overallScore: score.overallScore.toFixed(2),
      esgNotching: (E?.total || 0).toFixed(),
      overallEsgScore: (score.overallEsgScore || 0).toFixed(2),
      overallEvaluation: score.overallEvaluation,
    };
    return summary;
  }

  static round(amount: number | undefined | null | '', digits: number = 4) {
    if (!amount) return null;
    let rounded =
      Math.round(amount * Math.pow(10, digits)) / Math.pow(10, digits);
    return rounded;
  }
}
